import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/api/login`, { username, password });
      if (response.data.success) {
        localStorage.setItem('authToken', response.data.token); // Lagre token
        navigate('/admin/dashboard'); // Send til dashboard
      }
    } catch (err) {
      setError('Ugyldig brukernavn eller passord.');
    }
  };

  return (
    <div className="login-container container">
        <Helmet>
        <title>Admin Innlogging</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <form onSubmit={handleLogin} className="login-form card">
      <img src="/logo.svg" alt="Logo" className="login-logo" />
        <h2>Admin Innlogging</h2>
        <div className="form-group">
          <label htmlFor="username">Brukernavn</label>
          <input 
            type="text" 
            id="username" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Passord</label>
          <input 
            type="password" 
            id="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="button">Logg inn</button>
        <Link to="/" className="back-to-site-link">
          Har du kommet feil? Gå til forsiden &#10140;
        </Link>
      </form>
    </div>
  );
}

export default LoginPage;